<div class="flex justify-between items-center flex-wrap h-1/2 bg-[#F8F9FA]">
    <div class="flex items-center flex-wrap">
        <div class="m-0 p-0 place-items-center flex">
            <i nz-icon class="cursor-pointer">
                <a [routerLink]="['/dashboard']" aria-label="Go to Dashboard" title="Dashboard">
                    <img src="/assets/svg/hezkytech_logo.svg" NgOptimizedImage class="w-40" alt="hezkytech"
                        loading="eager" />
                </a>
            </i>
        </div>
        <ul nz-menu nzMode="horizontal" class="hidden desktop:block border-none bg-[#F8F9FA]">
            <li nz-menu-item nzMatchRouter>
                <a [routerLink]="['/dashboard']" aria-label="Go to Dashboard" title="Dashboard">Dashboard</a>
            </li>
            <li nz-menu-item nzMatchRouter>
                <a [routerLink]="['/customer-management']" aria-label="Go to Customer" title="Assets">Customer
                    Management</a>
            </li>
            <li nz-submenu [nzTitle]="management">
                <ul>
                    <li nz-menu-item nzMatchRouter [routerLink]="['/management/certificate']">Certificate Management
                    </li>
                    <li nz-menu-item nzMatchRouter [routerLink]="['/management/inventory']">Inventory Management</li>
                    <li nz-menu-item nzMatchRouter [routerLink]="['management/device']">Device Management</li>
                    <li nz-menu-item nzMatchRouter [routerLink]="['management/master']">Master Management</li>
                    <li nz-menu-item nzMatchRouter [routerLink]="['/management/feature']">Feature Management</li>
                </ul>
            </li>
            <ng-template #management>
                <span class="hover:text-blue-500">Management</span>
                <i nz-icon nzType="caret-down" style="font-size: 12px;" class="ml-1" nzTheme="outline"></i>
            </ng-template>
        </ul>
    </div>
    <div class="flex items-center gap-2">
        <ul nz-menu nzMode="horizontal" class="border-none bg-[#F8F9FA] hidden tablet:flex">
            <li nz-submenu [nzTitle]="profileDropdown" nzPlacement="bottomRight" aria-label="Profile">
                <ul class="rounded-md shadow-md">
                    <li nz-menu-item [routerLink]="['/account-settings']">
                        <i class="mr-2" nz-icon nzType="user" nzTheme="outline"></i> Account Settings
                    </li>
                    <li nz-menu-item routerLink="/auth/login" (click)="authenticationSvc.onLogout()">
                        <i class="mr-2" nz-icon [nzType]="'hezky:Sign_Out'" nzTheme="outline"></i> Logout
                    </li>
                </ul>
            </li>
        </ul>
        <ng-template #profileDropdown>
            <span class="text-sm font-medium text-gray-600">{{ admin_name }}</span>
            <i nz-icon nzType="caret-down" style="font-size: 12px;" class="ml-1" nzTheme="outline"></i>
        </ng-template>
    </div>
</div>

<!-- Do For Mobile Responsiveness  -->
<!-- <nz-drawer [nzWidth]="250" [nzClosable]="false" [nzVisible]="drawer" (nzOnClose)="drawer = false" nzPlacement="left">
    <ng-container *nzDrawerContent>
        <ul nz-menu nzMode="inline" class="border-none w-100">
            <li nz-submenu [nzTitle]="commonSvc['user_data']['first_name']" nzPlacement="bottomRight" class="tablet:hidden"
                aria-label="Profile">
                <ul>
                    <li nz-menu-item [routerLink]="['/account-settings']">
                        <i class="mr-2" nz-icon nzType="user" nzTheme="outline"></i> Account Settings
                    </li>
                    <li nz-menu-item [routerLink]="['/get-support']">
                        <i class="mr-2 rotate-180" nz-icon nzType="phone" nzTheme="outline"></i> Get Support
                    </li>
                    <li nz-menu-item routerLink="/auth/login" (click)="authenticationSvc.onLogout()">
                        <i class="mr-2" nz-icon [nzType]="'hezky:Sign_Out'" nzTheme="outline"></i> Logout
                    </li>
                </ul>
            </li>
            <li nz-menu-item nzMatchRouter>
                <a [routerLink]="['/dashboard']" aria-label="Go to Dashboard" title="Dashboard">Dashboard</a>
            </li>
            <li nz-menu-item nzMatchRouter *ngIf="!commonSvc.roleService.hasAccess([4])">
                <a [routerLink]="['/assets']" aria-label="Go to Assets" title="Assets">Assets</a>
            </li>
            <li nz-menu-item nzMatchRouter *ngIf="!commonSvc.roleService.hasAccess([4])">
                <a [routerLink]="['/incidents']" aria-label="Go to Incidents" title="Incidents">Incidents</a>
            </li>
            <li nz-menu-item nzMatchRouter *ngIf="!commonSvc.roleService.hasAccess([3, 4])">
                <a [routerLink]="['/reports']" aria-label="Go to Reports" title="Reports">Reports</a>
            </li>
            <li nz-submenu nzTitle="Admin" *ngIf="commonSvc.roleService.hasAccess([0,1])">
                <ul>
                    <li nz-menu-item nzMatchRouter [routerLink]="['admin/group-management']"
                        *ngIf="commonSvc.roleService.hasAccess([0])">Group Management</li>
                    <li nz-menu-item nzMatchRouter [routerLink]="['admin/product-management']"
                        *ngIf="commonSvc.roleService.hasAccess([0,1,2])">Product Management</li>
                    <li nz-menu-item nzMatchRouter [routerLink]="['admin/user-management']"
                        *ngIf="commonSvc.roleService.hasAccess([0,1,2])">User Management</li>
                    <li nz-menu-item nzMatchRouter [routerLink]="['admin/device-management']"
                        *ngIf="commonSvc.roleService.hasAccess([0])">Device Management</li>
                </ul>
            </li>
        </ul>
    </ng-container>
</nz-drawer> -->